import { createApp, type Component } from 'vue';
import type { Store } from 'vuex';

type MountProps = {
  element: HTMLElement;
  component: Component;
  store?: Store<unknown>;
};

// VueのコンポーネントをRootとしてelement要素に対してマウントする。
// その際に、element要素のdata-props属性をコンポーネントのpropsに変換して与える(data-props属性はJSON形式)。
// railsからコンポーネントに初期値を与えてマウントしたいときなどに。
export function mountVueWithProps({ element, component, store }: MountProps) {
  if (!element) {
    return;
  }

  const propsJSON = element.dataset.props;
  const props: Record<string, unknown> = propsJSON ? JSON.parse(propsJSON) : {};

  const app = createApp(component, props);

  if (store) {
    app.use(store);
  }

  app.mount(element);

  return app;
}
